import { PaginationComponentProps } from "react-data-table-component";
import { ChevronLeft, ChevronRight } from "react-feather";
import SearchableSelect from "../../../../CommonElements/SearchableSelect";

const LeavePagination = ({ rowsPerPage, rowCount, currentPage, onChangePage, onChangeRowsPerPage }: PaginationComponentProps) => {
  const pageCount = Math.max(1, Math.ceil(rowCount / rowsPerPage));
  const offset = (currentPage - 1) * rowsPerPage;
  const pages = Array.from({ length: pageCount }, (_, i) => i + 1).filter(value =>
    value === 1 || value === pageCount || Math.abs(value - currentPage) <= 1);
  return <div className="leave-pagination">
    <div className="leave-page-size">
      <span>Rows per page</span>
      <SearchableSelect name="leave-page-size" label="Rows per page" className="leave-page-size-select" value={rowsPerPage} searchable={false} showSelectedBadge={false} menuPlacement="top" options={[6, 10, 20, 50].map(size => ({ value: size, label: `${size} rows` }))} onChange={value => { onChangeRowsPerPage(Number(value), 1); onChangePage(1, rowCount); }} />
    </div>
    <span>Showing {rowCount ? offset + 1 : 0}–{Math.min(offset + rowsPerPage, rowCount)} of {rowCount} leaves</span>
    <div className="leave-page-buttons">
      <button type="button" disabled={currentPage <= 1} aria-label="Previous page" onClick={() => onChangePage(currentPage - 1, rowCount)}><ChevronLeft size={14} /></button>
      {pages.map((value, index) => <span key={value}>
        {index > 0 && value - pages[index - 1] > 1 && <span className="leave-page-gap">…</span>}
        <button type="button" className={value === currentPage ? "active" : ""} aria-label={`Page ${value}`} aria-current={value === currentPage ? "page" : undefined} onClick={() => onChangePage(value, rowCount)}>{value}</button>
      </span>)}
      <button type="button" disabled={currentPage >= pageCount} aria-label="Next page" onClick={() => onChangePage(currentPage + 1, rowCount)}><ChevronRight size={14} /></button>
    </div>
  </div>;
};
export default LeavePagination;
